export { ContentArea } from './ContentArea.styles';
